import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X, Sparkles } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const LINKS = [
  { label: "HOME", href: "#home", testid: "nav-link-home" },
  { label: "PAKET DEKORASI", href: "#paket", testid: "nav-link-paket" },
  { label: "GALERI", href: "#galeri", testid: "nav-link-galeri" },
  { label: "BOOKING", href: "#booking", testid: "nav-link-booking" },
  { label: "TENTANG KAMI", href: "#tentang", testid: "nav-link-tentang" },
  { label: "KONTAK", href: "#kontak", testid: "nav-link-kontak" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { content } = useContent();
  const brand = content.brand || {};

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (href) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-[#FAF6F0]/90 backdrop-blur-md border-b border-[#E5D7C5] py-3"
          : "bg-transparent py-5"
      }`}
      data-testid="site-navbar"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 flex items-center justify-between">
        <button
          onClick={() => scrollTo("#home")}
          className="flex items-center gap-2 group"
          data-testid="nav-brand"
        >
          <Sparkles className="w-5 h-5 text-[#C5A059]" />
          <div className="text-left leading-none">
            <div className="font-serif text-xl font-semibold text-[#1C1917] tracking-tight">
              {brand.name || "Ascarya Dekorasi"}
            </div>
            <div className="font-mono text-[9px] tracking-[0.25em] uppercase text-[#967C52] mt-0.5">
              {brand.tagline || "Event & Wedding Decoration"}
            </div>
          </div>
        </button>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              data-testid={l.testid}
              className="text-[11px] font-semibold tracking-widest uppercase text-[#4A443F] hover:text-[#C5A059] transition-colors relative after:absolute after:-bottom-1.5 after:left-0 after:h-px after:w-0 after:bg-[#C5A059] hover:after:w-full after:transition-all"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#booking")}
            data-testid="nav-cta-booking-button"
            className="px-5 py-2.5 rounded-full bg-[#1C1917] text-white text-[11px] font-semibold tracking-widest uppercase border border-[#1C1917] hover:bg-[#C5A059] hover:border-[#C5A059] transition-all"
          >
            Booking Sekarang
          </button>
        </nav>

        <button
          className="lg:hidden text-[#1C1917]"
          onClick={() => setOpen((o) => !o)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden mt-3 mx-5 rounded-2xl bg-[#FFFDF9] border border-[#E5D7C5] shadow-lg p-4 flex flex-col gap-1">
          {LINKS.map((l) => (
            <button
              key={l.href}
              onClick={() => scrollTo(l.href)}
              className="text-left px-4 py-3 rounded-xl text-xs font-semibold tracking-widest uppercase text-[#4A443F] hover:bg-[#F7F0E6]"
            >
              {l.label}
            </button>
          ))}
          <button
            onClick={() => scrollTo("#booking")}
            className="mt-2 px-4 py-3 rounded-xl bg-[#1C1917] text-white text-xs font-semibold tracking-widest uppercase"
          >
            Booking Sekarang
          </button>
        </div>
      )}
    </motion.header>
  );
};
